<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  name: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  options: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  radioType: {
    type: String,
    default: 'radio-enriched',
  },
});

const { t } = useI18n();

const radioValidationLabel = computed(() => {
  if (!props.label) {
    return t('general.radioValidationLabel');
  }
  return '';
});

const typeClasses = computed(() => {
  if (props.radioType === 'radio-enriched') return 'formkit-radio-wrapper';
  if (props.radioType === 'radio-skewed') return 'formkit-radio-wrapper skewed';
  return '';
});

const iconType = computed(() => {
  if (props.radioType === 'radio-basic-square') return 'check';
  return 'circle';
});
</script>

<template>
  <FormKit
    :id="name"
    type="radio"
    :name="name"
    :label="label"
    :options="options"
    :decorator-icon="iconType"
    :validation-label="radioValidationLabel"
    :classes="{
      fieldset: '$reset',
      options: typeClasses,
      option: radioType,
    }"
  />
</template>

<style lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '@/styles/base/typography';

.formkit-radio-wrapper {
  font-family: var(--font-medium);
  width: 100%;
  display: flex;

  .formkit-wrapper {
    width: calc(100% - 1.9rem) !important;
  }
}

.skewed {
  margin-left: 1.5rem !important;
  margin-top: 3rem !important;

  li:last-child {
    margin-bottom: auto !important;
  }
}

ul {
  gap: 1rem;
}
</style>
